import theme from "/var/lib/jenkins/workspace/Frontend/Archive/ExpertOption/Prod/Partner/src/styles/theme";
export default theme;
